import { FormField, FormFieldLabel } from '@retailer-platform/shared-components'
import React, { type FunctionComponent } from 'react'
import { Controller, useFormContext } from 'react-hook-form-7'
import { ImageUploader } from 'gin-and-tonic/containers/image-uploader/ImageUploader'
import clientEnv from 'utils/global/clientEnv'
import { useDomainMessages } from 'domains/retailer-collections/utils/domain/intl'

interface RetailerCollectionsFormAssetsProps {}

export const RetailerCollectionsFormAssets: FunctionComponent<
  RetailerCollectionsFormAssetsProps
> = () => {
  const { control } = useFormContext()
  const messages = useDomainMessages({
    tileImageUrlLabel: 'retailerCollectionsDomain.form.tileImageUrl.label',
  })

  return (
    <React.Fragment>
      <FormField>
        <FormFieldLabel optional>{messages.tileImageUrlLabel}</FormFieldLabel>

        <Controller
          control={control}
          name="tileImageUrl"
          render={({ field: { ref: _ref, ...fieldProps } }) => (
            <ImageUploader
              {...fieldProps}
              filestackApiKey={clientEnv.PUBLIC_CLIENT_FILEPICKER_API_KEY}
            />
          )}
        />
      </FormField>
    </React.Fragment>
  )
}
